import type { OrigemOrcamentoDto } from '@triade/contracts';

/** Selo "Vencido" (flag `vencido` da API: enviada/em negociacao com a validade da versao de referencia passada). */
export function SeloVencido() {
  return (
    <span data-testid="selo-vencido" className="inline-flex rounded-full bg-warning-bg px-2 py-0.5 text-caption font-semibold text-warning-ink">
      Vencido
    </span>
  );
}

/** Marca de orcamento importado do XARP (somente leitura). Criados no app nao mostram marca. */
export function SeloOrigem({ origem }: { origem: OrigemOrcamentoDto }) {
  if (origem !== 'IMPORTADO_XARP') return null;
  return (
    <span data-testid="selo-origem" className="inline-flex rounded-full border border-border bg-line-soft px-2 py-0.5 text-caption font-medium text-ink-secondary">
      Importado do XARP
    </span>
  );
}
